import React from "react";
import { monthConverter } from "utils/common";
import { UserLevel } from "utils/constant";

const TableComponent = ({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
}) => {
  const getTotal = (field) => {
    return reportsData.reduce((total, item) => total + (item[field] || 0), 0);
  };

  const renderTableByLevel = () => {
    switch (currentLevel) {
      case UserLevel.National:
      case UserLevel.Province:
        const total_jum_faskes = getTotal("jum_faskes");
        const total_jum_faskes_mikroskopis = getTotal("jum_faskes_mikroskopis");
        const total_jum_faskes_mikroskopis_ujisilang = getTotal(
          "jum_faskes_mikroskopis_ujisilang"
        );
        const total_cakupan_faskes = getTotal("cakupan_faskes");
        const total_jum_faskes_sensitifitas = getTotal(
          "jum_faskes_sensitifitas"
        );
        const total_cakupan_sensitifitas = getTotal("cakupan_sensitifitas");
        const total_jum_faskes_spesifisitas = getTotal(
          "jum_faskes_spesifisitas"
        );
        const total_cakupan_spesifisitas = getTotal("cakupan_spesifisitas");
        const total_jum_faskes_akurasi_spesies = getTotal(
          "jum_faskes_akurasi_spesies"
        );
        const total_cakupan_akurasi_spesies = getTotal(
          "cakupan_akurasi_spesies"
        );
        const total_jum_faskes_ujisilang_baik = getTotal(
          "jum_faskes_ujisilang_baik"
        );
        const total_cakupan_ujisilang_baik = getTotal("cakupan_ujisilang_baik");
        return (
          <>
            <thead>
              <tr>
                <th rowSpan={2}>No</th>
                <th rowSpan={2}>Provinsi</th>
                <th rowSpan={2}>Kab/Kota</th>
                <th colSpan={4}>Cakupan</th>
                <th colSpan={2}>Sensitifitas</th>
                <th colSpan={2}>Spesifisitas</th>
                <th colSpan={2}>Akurasi spesies</th>
                <th colSpan={2}>Hasil Uji Silang Baik</th>
              </tr>
              <tr>
                <th>Jumlah fasyankes</th>
                <th>Jumlah fasyankes melakukan pemeriksaan mikroskopis</th>
                <th>
                  Jumlah fasyankes melakukan pemeriksaan mikroskopis dan uji
                  silang
                </th>
                <th>%Cakupan [(3/2)*100]</th>
                <th>Jumlah fasyankes dengan densitifitas ≥70%</th>
                <th>% [(5/3)*100]</th>
                <th>Jumlah fasyankes dengan dpesifisitas ≥70%</th>
                <th>% [(7/3)*100]</th>
                <th>Jumlah fasyankes dengan akurasi spesies ≥70%</th>
                <th>% [(9/3)*100]</th>
                <th>Jumlah fasyankes dengan hasil uji silang baik</th>
                <th>%Hasil baik [(11/3)*100]</th>
              </tr>
            </thead>
            <tbody>
              {reportsData.length !== 0 ? (
                reportsData?.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.province_name}</td>
                    <td>{item?.district_name}</td>
                    <td>{item?.jum_faskes}</td>
                    <td>{item?.jum_faskes_mikroskopis}</td>
                    <td>{item?.jum_faskes_mikroskopis_ujisilang}</td>
                    <td>{item?.cakupan_faskes}</td>
                    <td>{item?.jum_faskes_sensitifitas}</td>
                    <td>{item?.cakupan_sensitifitas}</td>
                    <td>{item?.jum_faskes_spesifisitas}</td>
                    <td>{item?.cakupan_spesifisitas}</td>
                    <td>{item?.jum_faskes_akurasi_spesies}</td>
                    <td>{item?.cakupan_akurasi_spesies}</td>
                    <td>{item?.jum_faskes_ujisilang_baik}</td>
                    <td>{item?.cakupan_ujisilang_baik}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={15}>Tidak ada data</td>
                </tr>
              )}
              <tr style={{ backgroundColor: "#43766C" }}>
                <td style={{ color: "#FFF" }} colSpan={3}>
                  Total
                </td>
                <td style={{ color: "#FFF" }}>{total_jum_faskes}</td>
                <td style={{ color: "#FFF" }}>
                  {total_jum_faskes_mikroskopis}
                </td>
                <td style={{ color: "#FFF" }}>
                  {total_jum_faskes_mikroskopis_ujisilang}
                </td>
                <td style={{ color: "#FFF" }}>{total_cakupan_faskes}</td>
                <td style={{ color: "#FFF" }}>
                  {total_jum_faskes_sensitifitas}
                </td>
                <td style={{ color: "#FFF" }}>{total_cakupan_sensitifitas}</td>
                <td style={{ color: "#FFF" }}>
                  {total_jum_faskes_spesifisitas}
                </td>
                <td style={{ color: "#FFF" }}>{total_cakupan_spesifisitas}</td>
                <td style={{ color: "#FFF" }}>
                  {total_jum_faskes_akurasi_spesies}
                </td>
                <td style={{ color: "#FFF" }}>
                  {total_cakupan_akurasi_spesies}
                </td>
                <td style={{ color: "#FFF" }}>
                  {total_jum_faskes_ujisilang_baik}
                </td>
                <td style={{ color: "#FFF" }}>
                  {total_cakupan_ujisilang_baik}
                </td>
              </tr>
            </tbody>
          </>
        );
      case UserLevel.District:
        const total_jum_mikroskopis = getTotal("jum_mikroskopis");
        const total_jum_ujisilang = getTotal("jum_ujisilang");
        const total_pos_mikroskopis = getTotal("pos_mikroskopis");
        const total_neg_mikroskopis = getTotal("neg_mikroskopis");
        const total_jum_sd_pos = getTotal("jum_sd_pos");
        const total_jum_sd_neg = getTotal("jum_sd_neg");
        const total_diskordans = reportsData.reduce(
          (total, item) => total + (item.diskordans === "Ya" ? 1 : 0),
          0
        );
        return (
          <>
            <thead>
              <tr>
                <th>No</th>
                <th>Wilayah</th>
                <th>Jumlah fasyankes melakukan pemeriksaan mikroskopis</th>
                <th>Jumlah fasyankes melakukan pemeriksaan uji silang</th>
                <th>Pos mikroskopis</th>
                <th>Neg mikroskopis</th>
                <th>Jumlah SD positif</th>
                <th>Jumlah SD negatif</th>
                <th>Pembuatan SD tipis(%)</th>
                <th>Pembuatan SD tebal(%)</th>
                {/* <th>Nilai pewarnaan SD(%)</th> */}
                <th>Hasil pembuatan SD (data terakhir)</th>
                <th>Sensitivitas(%) (data terakhir)</th>
                <th>Spesifisitas(%) (data terakhir)</th>
                <th>Akurasi spesies(%) (data terakhir)</th>
                <th>Hasil uji silang</th>
                <th>Diskordans</th>
              </tr>
            </thead>
            <tbody>
              {reportsData.length !== 0 ? (
                reportsData?.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.wilayah}</td>
                    <td>{item?.jumfaskes_prksamal}</td>
                    <td>{item?.jumfaskes_ujisilang}</td>
                    <td>{item?.mikro_pos_total}</td>
                    <td>{item?.mikro_neg_total}</td>
                    <td>{item?.jumsdpos}</td>
                    <td>{item?.jumsdneg}</td>
                    <td>{item?.nilai_pmbt_sd_tpis}</td>
                    <td>{item?.nilai_pmbt_sd_tbal}</td>
                    {/* <td>{item?.nilai_pwrnaan_sd}</td> */}
                    <td>{item?.hslpmbuatansd4}</td>
                    <td>{item?.sensiti}</td>
                    <td>{item?.spesifi}</td>
                    <td>{item?.akrasi_spesies}</td>
                    <td>{item?.hslujisilang4}</td>
                    <td>{item?.diskordans4}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={17}>Tidak ada data</td>
                </tr>
              )}
              <tr style={{ backgroundColor: "#43766C" }}>
                <td style={{ color: "#FFF" }} colSpan={2}>
                  Total
                </td>
                <td style={{ color: "#FFF" }}>{total_jum_mikroskopis}</td>
                <td style={{ color: "#FFF" }}>{total_jum_ujisilang}</td>
                <td style={{ color: "#FFF" }}>{total_pos_mikroskopis}</td>
                <td style={{ color: "#FFF" }}>{total_neg_mikroskopis}</td>
                <td style={{ color: "#FFF" }}>{total_jum_sd_pos}</td>
                <td style={{ color: "#FFF" }}>{total_jum_sd_neg}</td>
                <td colSpan={7}></td>
                <td style={{ color: "#FFF" }}>
                  Jumlah diskordans = {total_diskordans}
                </td>
              </tr>
            </tbody>
          </>
        );
      default:
        const total_jumsdneg = getTotal("jumsdneg");
        const total_jumsdpos_mix = getTotal("jumsdpos_mix");
        const total_jumsdpos_pf = getTotal("jumsdpos_pf");
        const total_jumsdpos_pv = getTotal("jumsdpos_pv");
        const total_jumsdpos_po = getTotal("jumsdpos_po");
        const total_jumsdpos_pm = getTotal("jumsdpos_pm");

        return (
          <>
            <thead>
              <tr>
                <th>No</th>
                <th>Wilayah</th>
                <th>Bulan</th>
                <th>Petugas mikroskopis</th>
                <th>Jumlah sedian darah negatif</th>
                <th>Jumlah sedian darah positif mix</th>
                <th>Jumlah sedian darah positif pf</th>
                <th>Jumlah sedian darah positif pv</th>
                <th>Jumlah sedian darah positif po</th>
                <th>Jumlah sedian darah positif pm</th>
              </tr>
            </thead>
            <tbody>
              {reportsData.length !== 0 ? (
                reportsData?.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.fasyankes_id?.split("|")?.[1]}</td>
                    <td>{item?.month}</td>
                    <td>{item?.pjlab}</td>
                    <td>{item?.jumsdneg}</td>
                    <td>{item?.jumsdpos_mix}</td>
                    <td>{item?.jumsdpos_pf}</td>
                    <td>{item?.jumsdpos_pv}</td>
                    <td>{item?.jumsdpos_po}</td>
                    <td>{item?.jumsdpos_pm}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={10}>Tidak ada data</td>
                </tr>
              )}
              <tr style={{ backgroundColor: "#43766C" }}>
                <td style={{ color: "#FFF" }} colSpan={4}>
                  Total
                </td>
                <td style={{ color: "#FFF" }}>{total_jumsdneg}</td>
                <td style={{ color: "#FFF" }}>{total_jumsdpos_mix}</td>
                <td style={{ color: "#FFF" }}>{total_jumsdpos_pf}</td>
                <td style={{ color: "#FFF" }}>{total_jumsdpos_pv}</td>
                <td style={{ color: "#FFF" }}>{total_jumsdpos_po}</td>
                <td style={{ color: "#FFF" }}>{total_jumsdpos_pm}</td>
              </tr>
            </tbody>
          </>
        );
    }
  };

  let levelName = "";
  if (currentLevel === UserLevel.National) {
    levelName = "Nasional";
  } else if ([UserLevel.Province, UserLevel.LabTier3].includes(currentLevel)) {
    levelName = "Provinsi";
  } else if ([UserLevel.District, UserLevel.LabTier2].includes(currentLevel)) {
    levelName = "Kabupaten/Kota";
  } else {
    levelName = "Fasyankes";
  }

  let periodeName = "";
  if (reportInfo?.statusPeriode === "yearly") {
    periodeName = "Tahunan";
  } else {
    periodeName = "Bulanan";
  }

  let data = reportInfo?.fasyankes;
  let parts = data?.split(",");
  let faskesName = parts?.map(function (part) {
    return part?.split("|")[1];
  });
  let result = faskesName?.join(", ");

  return (
    <div
      className="table-table-responsive"
      ref={tableRef}
    >
      <table>
        <tr style={{ border: "none", padding: 0 }}>
          <th style={{ border: "none", paddingBottom: "0" }}>
            <h3>SISMAL v3, UJI SILANG</h3>
          </th>
        </tr>
      </table>
      <table>
        <tr style={{ border: "none" }}>
          <th
            width="200"
            style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}
          >
            Periode Laporan
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {periodeName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Tahun
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {reportInfo?.periode?.year}
          </th>
        </tr>
        {reportInfo?.statusPeriode === "monthly" && (
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Bulan
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {monthConverter(reportInfo?.periode?.month_start)} - {monthConverter(reportInfo?.periode?.month_end)}
            </th>
          </tr>
        )}
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Level
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {levelName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Provinsi
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.province
              ? "Semua Provinsi"
              : reportInfo?.province?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Kab/Kota
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.district
              ? "Semua Kab/Kota"
              : reportInfo?.district?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0 }}>Fasyankes</th>
          <th style={{ border: "none", paddingTop: 0 }}>
            : {!reportInfo?.fasyankes ? "Semua Fasyankes" : result}
          </th>
        </tr>
      </table>
      <table>{renderTableByLevel()}</table>
    </div>
  );
};

export default TableComponent;
